import React, { useContext, useEffect, useState } from "react"
import { FlatList, RefreshControl, TouchableOpacity, View } from "react-native"
import styles from "./styles"
import CustomSearchBar from "@Components/CustomSearchBar/CustomSearchBar"
import CustomVideoItem from "@Components/CustomVideoItem/CustomVideoItem"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import CustomBottomModal from "@Components/Modal/CustomBottomModal/CustomBottomModal"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { changeSelectedValue } from "@Utils/utils"
import { Button } from "@Components/CustomButton/Button"
import { ActivityIndicator, RadioButton } from "react-native-paper"
import { ArticleTypes, seenHistories } from "@Constants/constant"
import { PostService } from "@Services/Posts"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { QuizzContext } from "@Providers/QuizzProvider"
import { useConclusionHooks } from "../../../Hooks/useConclusionHooks"
import { useIsFocused } from "@react-navigation/native"

const ArticlePage = (props) => {
    const { navigation, axisId } = props
    const [searchQuery, setSearchQuery] = useState("")
    const [selectedId, setSelectedId] = useState(null)
    const [typesMedia, setTypesMedia] = useState([])
    const [selectedMedia, setSelectedMedia] = useState(null)
    const [alreadySeen, setAlreadySeen] = useState(null)
    const [isModalVisible, setModalVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [posts, setPosts] = useState([])
    const [filteredPosts, setFilteredPosts] = useState([])
    const [viewedPosts, setViewedPosts] = useState([])
    const toggleModal = () => setModalVisible(!isModalVisible)
    const { selectedKnowledge } = useContext(QuizzContext)
    const user = useRecoilValue(userAtom)
    const userId = user?.id ?? 0
    const isFocused = useIsFocused()

    const { handleFetchConclusion, conclusion, fetchingConclusions } = useConclusionHooks()

    useEffect(() => {
        handleFetchConclusion()
    }, [userId])

    const articleFromConclusionIds = conclusion?.conclusionVideos?.map((article) => article?.id)

    const renderItem = ({ item }) => <CustomVideoItem item={item} handlePress={handlePress} />

    const fetchAllPostViewed = () => {
        PostService.getAllViewed(user?.id)
            .then((response) => {
                const data = response.data?.data
                if (data && data instanceof Array && data.length > 0) {
                    setViewedPosts(data)
                }
            })
            .catch((e) => {
                console.log({ error: e })
                ShowToast({
                    type: "error",
                    message: "Oops une erreur est survenue lors de la récupération des articles lu"
                })
            })
    }

    const fetchAllPost = () => {
        setLoading(true)
        PostService.getAllPostByUserId({
            axisId,
            postTypeId: selectedMedia,
            postCategoryId: selectedKnowledge,
            isViewed: alreadySeen,
            userId,
            conclusionId: conclusion?.id
        })
            .then((response) => {
                const data = response.data?.data
                if (data && data instanceof Array) {
                    setPosts(data)
                    setFilteredPosts(data)
                    setLoading(false)
                }
            })
            .catch((e) => {
                console.log({ olana1: e })
                ShowToast({
                    type: "error",
                    message: "Oops une erreur est survenue lors de la récupération des articles"
                })
                setLoading(false)
            })
    }

    const fetchAllType = () => {
        PostService.getAllTypes().then((response) => {
            const data = response.data?.data
            if (data && data instanceof Array) {
                setTypesMedia(
                    data
                        .map((item) => {
                            return {
                                id: item.id,
                                name:
                                    item.code === ArticleTypes.image
                                        ? "Articles"
                                        : item.code === ArticleTypes.video
                                        ? "Vidéos"
                                        : "Autres"
                            }
                        })
                        .sort((a, b) => b.id - a.id)
                )
            }
        })
    }

    const handlePress = (content) => () => {
        const contentId = content?.id
        setSelectedId(contentId)
        navigation.navigate("VideosDetails", { contentId, content })
    }

    const mediaBgColor = (mediatype) =>
        selectedMedia === mediatype ? baseColors.green.primary : baseColors.green.light

    const mediaLabelColor = (mediatype) => (selectedMedia === mediatype ? baseColors.white : baseColors.green.primary)

    const clearFilter = () => {
        setSelectedMedia(null)
        setAlreadySeen(null)
    }

    useEffect(() => {
        fetchAllPost()
        fetchAllPostViewed()
        fetchAllType()
        // return () => {
        //     clearFilter()
        // }
    }, [selectedKnowledge, conclusion?.id, axisId, isFocused, alreadySeen])

    const handleMediaFilter = () => {
        setSearchQuery("")
        fetchAllPost()
    }

    const handleSearch = () => {
        if (searchQuery.trim().length > 0) {
            setFilteredPosts(
                posts
                    .filter((item) => item?.title?.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1)
                    .filter((item) => (selectedMedia ? item.postType?.code === selectedMedia : true))
            )
        } else {
            setFilteredPosts(posts.filter((item) => (selectedMedia ? item.postType?.code === selectedMedia : true)))
        }
    }

    useEffect(() => {
        handleSearch()
    }, [searchQuery])

    const articles = articleFromConclusionIds

    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <CustomSearchBar
                    showFilter
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    toggleModal={toggleModal}
                />
            </View>

            <View style={styles.videosContent}>
                {loading ? (
                    <ActivityIndicator style={{ padding: 30 }} size={"small"} color={baseColors.green.primary} />
                ) : (
                    <FlatList
                        data={filteredPosts}
                        renderItem={renderItem}
                        keyExtractor={(item) => item.id.toString()}
                        refreshing={loading}
                        refreshControl={<RefreshControl refreshing={loading} onRefresh={() => fetchAllPost()} />}
                        extraData={selectedId}
                        contentContainerStyle={styles.contentContainer}
                        ListEmptyComponent={() => (
                            <View>
                                <OpenSansText textAlign="center" fontSize={20}>
                                    Aucun résultat
                                </OpenSansText>
                            </View>
                        )}
                        initialNumToRender={5}
                    />
                )}
            </View>

            <CustomBottomModal toggleModal={toggleModal} open={isModalVisible}>
                <View style={styles.mediaContainer}>
                    <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={18}>
                        Type de média
                    </OpenSansText>

                    <View style={styles.media}>
                        {typesMedia.map((media) => (
                            <TouchableOpacity
                                key={media.id}
                                style={{
                                    ...styles.mediaLabel,
                                    backgroundColor: mediaBgColor(media.id)
                                }}
                                onPress={() => changeSelectedValue(media.id, setSelectedMedia)}
                            >
                                <OpenSansText
                                    style={{ color: mediaLabelColor(media.id) }}
                                    defaultFontFamily={baseFontFamily.OpenSansRegular}
                                    fontSize={RFValue(16)}
                                >
                                    {media.name}
                                </OpenSansText>
                            </TouchableOpacity>
                        ))}
                    </View>
                </View>

                <View style={styles.mediaContainer}>
                    <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={18}>
                        Historique des médias
                    </OpenSansText>

                    <View style={styles.radioGroupContainer}>
                        {seenHistories.map((item) => (
                            <TouchableOpacity
                                key={item.id}
                                style={styles.radioContainer}
                                onPress={() => changeSelectedValue(item.seen, setAlreadySeen)}
                            >
                                <View style={styles.radioContent}>
                                    <RadioButton.Android
                                        color={baseColors.green.primary}
                                        onPress={() => changeSelectedValue(item.seen, setAlreadySeen)}
                                        status={alreadySeen === item.seen ? "checked" : "unchecked"}
                                    />
                                    <OpenSansText fontSize={RFValue(16)}>{item.label}</OpenSansText>
                                </View>
                            </TouchableOpacity>
                        ))}
                    </View>
                </View>

                <Button
                    onPress={() => {
                        handleMediaFilter()
                        toggleModal()
                    }}
                    text="Filtrer"
                    width="70%"
                    height={RFValue(50)}
                    backgroundColor={baseColors.green.primary}
                    labelColor={"white"}
                />

                <TouchableOpacity
                    style={styles.clearFilter}
                    onPress={() => {
                        clearFilter()
                        // fetchAllPost()
                        // toggleModal()
                    }}
                >
                    <OpenSansText
                        style={styles.clearFilterLabel}
                        defaultFontFamily={baseFontFamily.OpenSansBold}
                        fontSize={RFValue(16)}
                    >
                        Effacer les filtres
                    </OpenSansText>
                </TouchableOpacity>
            </CustomBottomModal>
        </View>
    )
}

export default ArticlePage
